import React from 'react';
import { FormGroup, TextArea } from '@patternfly/react-core';

type Props = {
  id?: string;
  label?: string;
  name?: string;
  onChange?: (value: string) => void;
  value?: string;
  readonly?: boolean;
  required?: boolean;
};

const PatternflyTextArea = ({
  id,
  label,
  name,
  onChange,
  readonly,
  required,
  value,
}: Props) => (
  <FormGroup label={label} isRequired={required}>
    <TextArea
      id={id}
      isDisabled={readonly}
      isRequired={required}
      name={name}
      onChange={(_, text) => onChange(text)}
      resizeOrientation="vertical"
      value={value}
    />
  </FormGroup>
);

export default PatternflyTextArea;
